export const nftsData = [
  {
    name: "Dao Vinci",
    number: "#0000",
    avatar: "./avatars/crispin.svg",
    username: "SalvadorDali",
    price: "4.89",
    time: "05:12:07:26",
    image: "./assets/dao-vinci.svg",
    category: "Music",
  },

  {
    name: "Fangster",
    number: "#8668",
    avatar: "./avatars/wade.svg",
    username: "Kurrebe",
    price: "4.09",
    time: "02:12:07:26",
    image: "./assets/nft-pics/fangster.svg",
    category: "Art",
  },

  {
    name: "Cute Shiba",
    number: "#0000",
    avatar: "./avatars/robert.svg",
    username: "Noche",
    price: "7.89",
    time: "00:01:07:26",
    image: "./assets/nft-pics/cute-shiba.svg",
    category: "Sports",
  },

  {
    name: "Sherbet",
    number: "#3062",
    avatar: "./avatars/jacob.svg",
    username: "Noche",
    price: "2.29",
    time: "01:11:07:26",
    image: "./assets/nft-pics/sherbet.svg",
    category: "Virtual",
  },

  {
    name: "Monkey",
    number: "#9973",
    avatar: "./avatars/ralph.svg",
    username: "SalvadorDali",
    price: "4.89",
    time: "05:12:07:26",
    image: "./assets/nft-pics/cute-monkey.svg",
    category: "Videos",
  },

  {
    name: "Disco",
    number: "#9973",
    avatar: "./avatars/ralph.svg",
    username: "SalvadorDali",
    price: "4.89",
    time: "05:12:07:26",
    image: "./assets/image-7.svg",
    category: "Art",
  },

  {
    name: "Astro",
    number: "#1000",
    avatar: "./avatars/arlene.svg",
    username: "SalvadorDali",
    price: "4.89",
    time: "05:12:07:26",
    image: "./assets/nft-pics/astro.svg",
    category: "Music",
  },

  {
    name: "Hamlet...",
    number: "#5600",
    avatar: "./avatars/kurrebe.svg",
    username: "SalvadorDali",
    price: "8.89",
    time: "00:02:00:26",
    image: "./assets/nft-pics/doodle-1.svg",
    category: "Music",
  },
];
